import { render, staticRenderFns } from "./searchComponent.vue?vue&type=template&id=20b78428&"
import script from "./searchComponent.vue?vue&type=script&lang=js&"
export * from "./searchComponent.vue?vue&type=script&lang=js&"
import style0 from "./searchComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports